export default __webpack_public_path__ + "static/media/84a735d723f9776c.bc43d907e96ef3b1ab4b5d7c5f7c3e10.svg";